import React, { useEffect, useState } from 'react';
import columns from '../../../columns/ib/IBTree.js';
import { GetIBTreeApi } from '../../../api/request/ib/ibTree.js';
import { useSelector } from "react-redux";
import { Table } from 'antd';

export default function IBTree() {

    const { userDetails } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);

    const convertDataToTree = (data) => {
        const traverse = (node) => {
            return {
                name: node?.fullName,
                level: node?.level || 0,
                key: `${node?.userId}`,
                count: node?.userCount || 0,
                email: node?.email,
                mobileNo: node?.phoneNo ? node?.phoneNo : '--',
                children: node.childrenUser.length ? node.childrenUser.map(traverse) : null,
            };
        };
        return [traverse(data)];
    };

    // const convertDataToTree = (data) => {
    //     return [{
    //         name: data?.fullName,
    //         level: data?.level || 0,
    //         key: `${data?.userId}`,
    //         count: data?.userCount || 0,
    //         email: data?.email,
    //         mobileNo: data?.phoneNo ? data?.phoneNo : '--',
    //         children: data.childrenUser?.map((child) => ({
    //             name: child?.fullName,
    //             level: child?.level || 0,
    //             key: `${child?.userId}`,
    //             count: child?.userCount || 0,
    //             email: child?.email,
    //             mobileNo: child?.phoneNo ? child?.phoneNo : '--',
    //             children: null,
    //         })) || null,
    //     }];
    // };
    const getIbTree = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetIBTreeApi(userDetails?._id);
            if (data?.success) {
                setData(convertDataToTree(JSON.parse(data?.data)));
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getIbTree();
    }, []);

    return (
        <div className="border border-gray-200 rounded-xl hover-disabled-table">
            <Table columns={columns} dataSource={data} loading={isLoading} pagination={false} className='table-responsive' />
        </div>
    )
}